/**
 * Created with IntelliJ IDEA.
 * User: nzamuruev
 * Date: 16.10.13
 * Time: 18:01
 * To change this template use File | Settings | File Templates.
 */

import { BasicTrackingEvent } from "./BasicTrackingEvent";

export class ShopHelpButtonTrackingEvent extends BasicTrackingEvent {
    public playerId: number;
    public lang: string;

    constructor(referrer: string) {
        super(referrer);
    }

    public getVars(): any {
        let vars: any = {};
        vars.playerId = this.playerId;
        vars.lang = this.lang;
        return vars;
    }
}
